export default __webpack_public_path__ + "static/company-73f9a9e074563ffb56d5e4400a299cbb.mp4";